import React from "react";
import PropTypes from "prop-types";
import selectn from "selectn";
import classNames from "classnames";

import CardWrapper from "cards/components/CardWrapper";
import Microdata from "cards/components/Microdata";
import SplitLayout from "components/Library/Layout/components/SplitLayout";
import BylineWrapper from "cards/components/BylineWrapper";
import TextOverHeadline from "cards/components/TextOverHeadline";
import Headline from "cards/components/Headline";
import PrimaryImage from "cards/components/PrimaryImage";
import StoryBody from "components/Library/StoryBody";
import TagLink from "cards/components/TagLink";
import ShareLinks from "cards/components/ShareLinks";

import { FACTS_MATTER_TEMPLATE } from "config/constants";
import styles from "./FullStoryCard.css";
import FULL_STORY_CARD_FRAGMENT from "./FullStoryCard.graphql";

export default class FullStoryCard extends React.Component {
  static fragments = { content: FULL_STORY_CARD_FRAGMENT };

  render() {
    const { story, isFeatured, index } = this.props;

    return (
      <CardWrapper
        className={classNames({
          [styles.factsMatter]: story.template === FACTS_MATTER_TEMPLATE,
          [styles.featured]:
            isFeatured &&
            !selectn("rubric.name", story) &&
            story.template !== FACTS_MATTER_TEMPLATE,
        })}
        wrapperTag="article"
        role="article"
        ariaLabel={story.headline}
      >
        <Microdata story={story} />
        <BylineWrapper
          story={story}
          className={styles.header}
          showSaveTag={true}
        />
        <TextOverHeadline rubric={story.rubric} isFeatured={isFeatured} />
        <Headline headline={story.headline} />
        <PrimaryImage image={story.primary_image} lazyload={!!index} />
        <StoryBody
          story={story}
          renderMicrodata={true}
          isOpenOnMount={this.props.isOpen}
        />
        <SplitLayout
          left={<TagLink tag={story.primary_tag} additionalTags={story.tags} />}
          right={
            <ShareLinks headline={story.headline} permalink={story.permalink} />
          }
          leftClassName={styles.tagButton}
        />
      </CardWrapper>
    );
  }
}

FullStoryCard.propTypes = {
  story: PropTypes.object.isRequired,
  isFeatured: PropTypes.bool,
  index: PropTypes.number.isRequired,
  isOpen: PropTypes.bool,
};
